module.exports = __webpack_public_path__ + "img/smirking_face.ea5d21cd.gif";